/**
 *
 * WidgetOutcomeOld
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Popover, Divider } from "antd"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class WidgetOutcomeOld extends React.Component {
  render() {
    let { data, showTitle } = this.props
    data = data || []

    return (
      <Fragment>
        {showTitle && (
          <div className="subtitle_section color-black">Outcomes</div>
        )}

        <div
          className="WidgetOutcomeOld-body"
          style={data.length > 0 ? { paddingRight: 10 } : {}}>
          {data.map((e, i) => {
            return (
              <div
                key={i}
                className="WidgetOutcomeOld-body-item"
                style={{
                  backgroundColor: `${e.color}16`,
                  height: data.length === 1 ? 66 : "auto",
                }}>
                <div className="WidgetOutcomeOld-body-item-title">
                  <Popover
                    content={
                      <div style={{ maxWidth: 350, textAlign: "justify" }}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: e.dimension_description || e.dimension_name,
                          }}
                        />
                        <Divider
                          style={{
                            margin: "10px -16px",
                            textAlign: "justify",
                            width: "calc(100% + 32px)",
                          }}
                        />
                        {e.metrics_questions && e.metrics_questions.length > 0 && (
                          <Fragment>
                            <b style={{ color: "#878787" }}>Pregunta:</b>
                            <br />
                            {e.metrics_questions.map((x, iQ) => (
                              <Fragment key={iQ}>
                                {x.name} <br />
                              </Fragment>
                            ))}
                          </Fragment>
                        )}
                      </div>
                    }>
                    <span>{e.name}</span>
                  </Popover>
                </div>
                <div className="WidgetOutcomeOld-body-item-content">
                  <span
                    className="WidgetOutcomeOld-body-item-content-left"
                    style={{ color: e.color }}>
                    {e.value_visible}
                  </span>
                  <span className="WidgetOutcomeOld-body-item-content-right">
                    {e.valueAlternate}
                  </span>
                </div>
              </div>
            )
          })}
        </div>
      </Fragment>
    )
  }
}

WidgetOutcomeOld.propTypes = {}

export default WidgetOutcomeOld
